import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {apiLink} from '../../../mainurl'



function BranchwisePercent() {
  const [branchwisePercent,setBranchwisePercent]=useState("");

  useEffect(() => {
    fetch(
      apiLink+"stats/placed_branchwise_placedratio_graph" ,
      {
        method: "GET",
        headers: {
          'accept': "application/json",
          Authorization: "Bearer "+localStorage.getItem('access-token')
        },
      }
    ).then((response) => response.json())
    .then((data) => {
        setBranchwisePercent(data);
    });
  }, [])
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
      title: {
        display: true,
        text: 'Branchwise %age placed',
      },
    },
  };

  const labels = branchwisePercent.branch;

  const data = {
    labels,
    datasets: [
      {
        label: '%age Placed',
        data:  branchwisePercent.ratio,
        backgroundColor: '#A1C298',
      }
    ],
  };

  return <Bar options={options} data={data} />;
}
export default BranchwisePercent;
